import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Checkbox } from 'semantic-ui-react';

import {
  selectConstructorConfiguration,
  setDemoModeEnabled,
  setTelemetryDemoModeEnabled,
} from 'app/redux/constructorConfiguration/reducer';
import TechnicianPasswordValidationContext from 'app/providers/TechnicianPasswordValidationProvider/context';

export default function ConstructorPanelConfiguration() {
  const constructorConfiguration = useSelector(selectConstructorConfiguration);
  const dispatch = useDispatch();
  const requestTechnicianPassword = React.useContext(TechnicianPasswordValidationContext);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
      <Checkbox
        checked={constructorConfiguration?.isDemoModeEnabled ?? false}
        onChange={(e, { checked }) =>
          requestTechnicianPassword()
            .then(() => {
              dispatch(setDemoModeEnabled(!!checked));
            })
            .catch(() => {})
        }
        label={
          <label>
            <FormattedMessage id="account.configuration.demo_mode.enabled" />
          </label>
        }
      />
      <Checkbox
        checked={constructorConfiguration?.isTelemetryDemoEnabled ?? false}
        onChange={(e, { checked }) =>
          requestTechnicianPassword()
            .then(() => {
              dispatch(setTelemetryDemoModeEnabled(!!checked));
            })
            .catch(() => {})
        }
        label={
          <label>
            <FormattedMessage id="account.configuration.demo_mode_telemetry.enabled" />
          </label>
        }
      />
    </div>
  );
}
